export default __webpack_public_path__ + "static/media/counselor_management.0a7ac460.png";